import React from 'react';
import { Slide } from '../components/deck/Slide';
import { Caption, Eyebrow, INK, Reveal, Title } from '../components/deck/Type';
const tiers = [{
  tone: INK.emerald,
  label: 'Paying enterprise customer',
  names: ['Sony Innovation Fund'],
  note: '$100K paid 12-month engagement.'
}, {
  tone: INK.blue,
  label: 'Signed venture funds',
  names: ['Five venture funds'],
  note: 'Signed or engaged on DiligenceGPT™ workspaces.'
}, {
  tone: INK.violet,
  label: 'Programs & pilots',
  names: ['Techstars', 'Village Capital'],
  note: 'Venture program relationships and pilot activity.'
}, {
  tone: INK.gold,
  label: 'Research & ecosystem',
  names: ['World Bank Group', 'IBM'],
  note: 'Completed collaboration and ecosystem relationships.'
}];
export function ValidationSlide() {
  return <Slide index={8} data-id="element-323" data-mp="27h6j9mbp3hg4">
      <div className="flex items-start justify-between gap-[3vw]" data-id="element-324" data-mp="22g0o7hukbi3f">
        <div className="max-w-[60%]" data-id="element-325" data-mp="22fqzdxl97gzb">
          <Eyebrow data-id="element-326" data-mp="2wg21hiih5zk1">Institutional validation</Eyebrow>
          <Title className="mt-[2.2vh]" data-id="element-327" data-mp="2wf8vijrcbe2y">
            Built with — and trusted across — the venture ecosystem.
          </Title>
        </div>
        <Caption className="max-w-[30%] text-right" data-id="element-328" data-mp="35gq5dke5mjj7">
          Relationships are shown by type. Not every organization is a paying
          customer.
        </Caption>
      </div>

      <div className="mt-auto grid grid-cols-4 gap-[2vw]" data-id="element-329" data-mp="3ad75ze2jiqd6">
        {tiers.map((tier, i) => <Reveal key={tier.label} delay={0.08 * i} className="flex h-full flex-col" data-id="element-330" data-mp="2cpq2xdvh1ntn" data-mpi={i}>
            <div className="mb-[2.2vh] h-px w-full" style={{
          background: tier.tone
        }} data-id="element-331" data-mp="2mpgtj4gwviog" />
            <span className="text-[clamp(7.5px,0.78vw,16px)] uppercase tracking-[0.22em]" style={{
          color: tier.tone
        }} data-id="element-332" data-mp="2rgfeihcuh4y1">
              {tier.label}
            </span>
            <div className="mt-[2vh] space-y-[1.2vh]" data-id="element-333" data-mp="1yzuwono0hfjm">
              {tier.names.map(name => <p key={name} className="text-[clamp(14px,1.6vw,34px)] leading-tight text-[#F4F7FC]" style={{
            fontFamily: 'var(--font-serif)'
          }} data-id="element-334" data-mp="1qz6rkfc6dzkv">
                  {name}
                </p>)}
            </div>
            <Caption className="mt-auto pt-[2vh]" data-id="element-335" data-mp="1vqoqkxun1q37">{tier.note}</Caption>
          </Reveal>)}
      </div>

      <Reveal delay={0.42} className="mt-[3.4vh] flex items-center justify-between border-t border-white/12 pt-[2vh]" data-id="element-336" data-mp="1802l9ec0qjww">
        <p className="text-[clamp(11px,1.18vw,25px)] text-[#C3CBD9]" data-id="element-337" data-mp="14124e1d3prcj">
          20,000+ startups assessed across funds, accelerators and venture
          programs.
        </p>
        <span className="text-[clamp(8px,0.82vw,17px)] uppercase tracking-[0.22em] text-[#8B95A8]" data-id="element-338" data-mp="1cz5sn5fh1281">
          Two provisional patents filed
        </span>
      </Reveal>
    </Slide>;
}